import { createContext } from 'react'

const kitsuContext = createContext();

export default kitsuContext;